(() => {
  const ROOT='[data-stbridge]';

  function variantId(root){
    const form=root.closest('form');
    return form?.querySelector('input[name="id"]')?.value || form?.querySelector('select[name="id"]')?.value || '';
  }

  function buildUrl(root){
    const origin=root.dataset.designerOrigin;
    const url=new URL(origin);
    url.searchParams.set('profile',root.dataset.profile || 'generic');
    url.searchParams.set('product',root.dataset.productId || '');
    url.searchParams.set('variant',variantId(root));
    return url.href;
  }

  function open(root){
    const dialog=root.querySelector('[data-stbridge-dialog]');
    const frame=root.querySelector('[data-stbridge-frame]');
    if(!dialog || !frame) return;
    frame.src=buildUrl(root);
    if(typeof dialog.showModal==='function') dialog.showModal();
    else dialog.setAttribute('open','');
  }

  function close(root){
    const dialog=root.querySelector('[data-stbridge-dialog]');
    if(!dialog) return;
    if(typeof dialog.close==='function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click',event=>{
    const opener=event.target.closest('[data-stbridge-open]');
    if(opener){
      const root=opener.closest(ROOT);
      if(root) open(root);
      return;
    }

    const closer=event.target.closest('[data-stbridge-close]');
    if(closer){
      const root=closer.closest(ROOT);
      if(root) close(root);
    }
  });

  window.addEventListener('message',event=>{
    if(event.origin!=='https://stampadiko-designer.stampadikostudio.workers.dev') return;
    if(event.data?.type!=='STAMPADIKO_DESIGN_DONE') return;

    document.querySelectorAll(ROOT).forEach(root=>{
      const frame=root.querySelector('[data-stbridge-frame]');
      if(!frame || event.source!==frame.contentWindow) return;

      const id=String(event.data.designId || '');
      root.querySelector('[data-stbridge-id]').value=id;

      const profile=String(event.data.properties?.['_Designer profile'] || root.dataset.profile || '');
      root.querySelector('[data-stbridge-profile]').value=profile;

      const state=root.querySelector('[data-stbridge-state]');
      if(state) state.textContent=id ? '✓ Σχέδιο έτοιμο — '+id : '✓ Σχέδιο έτοιμο';

      const notes=root.closest('form')?.querySelector('[data-st-notes]');
      if(notes && !notes.value.trim()) notes.value=id ? 'Designer ID: '+id : 'Designer completed';

      close(root);
    });
  });
})();